import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';
import { PaymentPosting } from '@/backend/types/paymentPosting.type';

const paymentPosting = {
  fetchRowData: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/payment-posting', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  insertData: async (data: {
    document_type: string;
    title: string;
    url: string;
    uploaded_by: string | undefined;
    companyId: Number | undefined;
  }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/payment-posting',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  editTitle: async (data: Partial<PaymentPosting>) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.patch(
        '/payment-posting/edit-title',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateStatus: async (data: Partial<PaymentPosting>) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/payment-posting/update-status',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  allocateData: async (
    data: Partial<PaymentPosting> & {
      allocations: [
        {
          outcome_status: string;
          patient_id: string;
          payment_posted_amt: string;
          notes?: string;
          uniqueId: string;
        },
      ];
    }
  ) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/payment-posting/allocate', data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default paymentPosting;
